module.exports = __webpack_public_path__ + "img/ddwu_gallery7.e348b422.jpg";